import React, { useContext } from 'react';
import style from '../style.module.less';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { AutoBatchingContext } from '../context';

const AutoBatchResponse = () => {
  const { autoBatchResponse, totalRecords } = useContext(AutoBatchingContext);
  const { orderCountToTotalBatches, totalBatchCount } = autoBatchResponse;
  const hasConsistentCount = orderCountToTotalBatches.length === 1;
  const firstRangeLabel = totalBatchCount === 2 && !hasConsistentCount ? '1' : `1 - ${orderCountToTotalBatches[0].totalBatchesWithCount}`;

  return (
    <>
      <div className={style['results-block']}>
        <div className={style['results-header']}>
          <div>
            <FormattedMessage {...messages.autoBatchingResponseTotalBatchesHeader} />
          </div>
          <div>
            <FormattedMessage {...messages.autoBatchingResponseTotalOrdersHeader} />
          </div>
        </div>
        <div className={style['results-row']}>
          <div>{totalBatchCount}</div>
          <div>{totalRecords}</div>
        </div>
      </div>
      <div className={style['results-block']}>
        <div className={style['results-header']}>
          <div>
            <FormattedMessage {...messages.autoBatchingResponseBatchHeader} />
          </div>
          <div>
            <FormattedMessage {...messages.autoBatchingResponseOrdersPerBatchHeader} />
          </div>
        </div>
        <div className={style['results-row']}>
          <div>{firstRangeLabel}</div>
          <div>{orderCountToTotalBatches[0].orderCount}</div>
        </div>
        {!hasConsistentCount && (
          <div className={style['results-row']}>
            <div>{totalBatchCount}</div>
            <div>{orderCountToTotalBatches[1].orderCount}</div>
          </div>
        )}
      </div>
    </>
  );
};

export { AutoBatchResponse };
